import { render, staticRenderFns } from "./ReactionsV2.vue?vue&type=template&id=62e00700&scoped=true"
import script from "./ReactionsV2.vue?vue&type=script&lang=js"
export * from "./ReactionsV2.vue?vue&type=script&lang=js"
import style0 from "./ReactionsV2.vue?vue&type=style&index=0&id=62e00700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e00700",
  null
  
)

export default component.exports